export enum RiskAnalysisActionList {
  SET = '[RiskAnalysis] set',
  RESET = '[RiskAnalysis] reset',
}
